import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ItemGeneralListado } from '../../helpers/components/itemClasses/itemListadoGeneral.class';
import { ProductsService } from '../../infrastructure/services/products.service';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'sx-listado-productos',
  templateUrl: './product.list.component.html',
})
export class ProductListComponent implements OnInit {
  codSubscription: string;
  codChannel: string;
  urlAdicional: string;
  productos: Observable<ItemGeneralListado[]>;
  codorganization: string;

  constructor(private productsService: ProductsService, private aRoute: ActivatedRoute ) { }

  ngOnInit() {
    this.aRoute.params.subscribe((params: Params) => {
      this.codorganization = params['codorganizacion'];
      this.codSubscription = params['codsistema'];
      this.codChannel = params['codnegocio'];

      this.productos = this.productsService.getForList(this.codorganization,this.codSubscription, this.codChannel);
    });
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/product/product.list.component.ts